const codeApi = require('../api/codes');

function updateLootcoinBalance(result) {
  return {
    type: 'LOOTCOIN_BALANCE_UPDATED',
    lootcoinBonus: result.lootcoinBonus,
    newLootcoinBalance: result.newLootcoinBalance,
  };
}

function updateLootgemBalance(result) {
  return {
    type: 'LOOTGEM_BALANCE_UPDATED',
    lootgemBonus: result.lootgemBonus,
    newLootgemBalance: result.newLootgemBalance,
  };
}

function updateTicketBalance(result) {
  return {
    type: 'TICKET_BALANCE_UPDATED',
    ticketBonus: result.ticketBonus,
    newTicketBalance: result.newTicketBalance,
  };
}

function updateLastCodeRedeemDate() {
  return { type: 'LAST_CODE_REDEEM_DATE_UPDATED' };
}

function reportRedeemSuccessful(result, dispatch) {
  if (typeof result.newLootcoinBalance === 'number') {
    dispatch(updateLootcoinBalance(result));
  }
  if (typeof result.newLootgemBalance === 'number') {
    dispatch(updateLootgemBalance(result));
  }
  if (typeof result.newTicketBalance === 'number') {
    dispatch(updateTicketBalance(result));
  }
  switch (result.type) {
    case 'lootcoin':
    case 'lootgem':
    case 'ticket':
      return;
    case 'lootpack':
      dispatch({
        type: 'ADD_PURCHASE',
        purchase: result.purchase,
        timestamp: Date.now(),
      });
      return;
    case 'lootcard':
      dispatch({
        type: 'ADD_CARDS',
        cards: [result.card],
        timestamp: Date.now(),
      });
      return;
    default:
      dispatch({
        type: 'UNKNOWN_CODE_TYPE',
        timestamp: Date.now(),
      });
  }
}

function redeemCode(code, recaptchaToken, headers = {}) {
  return (dispatch, getState) => {
    const state = getState();
    const { apiUrl } = state.auth;
    const { token } = state.auth;
    if (!token) {
      return Promise.reject(new Error('Need to be logged in to redeem code'));
    }
    return codeApi
      .redeemCode(
        apiUrl,
        token,
        {
          code,
          recaptchaToken,
          'g-recaptcha-response': recaptchaToken,
        },
        headers,
      )
      .then(
        (responseJson) => {
          if (responseJson && responseJson.gotBonus) {
            dispatch(updateLastCodeRedeemDate());
            reportRedeemSuccessful(responseJson, dispatch);
          }
          return responseJson;
        },
        (error) => {
          throw error;
        },
      );
  };
}

module.exports = {
  redeemCode,
};
